import { BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Login from './Login';
import IdFind from "./IdFind";
import PwFind from "./PwFind";
import SignUp from "./SignUp";
import News from "./News";
import MyPage from "./MyPage";
import Home from "./Home";
import OAuth2RedirectHandler from './OAuth2RedirectHandler';
import NewsPrediction from "./NewsPrediction";
import Chat from "./Chat";
import Company from "./Company";
import CommentSection from "./CommentSection";
import SearchHistory from "./SearchHistory";
import Info from "./Info";
import InfoModel from "./InfoModel";
import InfoTeam from "./InfoTeam";
import InfoUse from "./InfoUse";
import Copyright from "./Copyright";
import CopyrightModel from "./CopyrightModel";
import Github from "./Github";
import Ask from "./Ask";
import Admin from "./Admin";
import AdminUpdate from "./AdminUpdate";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/idfind" element={<IdFind />} />
                <Route path="/pwfind" element={<PwFind />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/news" element={<News />} />
                <Route path="/mypage" element={<MyPage />} />
                <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />
                <Route path="/newsprediction" element={<NewsPrediction />} />
                <Route path="/Chat" element={<Chat />} />
                <Route path="/:company" element={<Company />} />
                <Route path="/CommentSection" element={<CommentSection />} />
                <Route path="/searchhistory" element={<SearchHistory />} />
                <Route path="/info" element={<Info />}>
                    <Route path="model" element={<InfoModel />} />
                    <Route path="team" element={<InfoTeam />} />
                    <Route path="use" element={<InfoUse />} />
                </Route>
                <Route path="/copyright" element={<Copyright />}>
                    <Route path="model" element={<CopyrightModel />} />
                </Route>
                <Route path="/github" element={<Github />} />
                <Route path="/ask" element={<Ask />} />
                <Route path="/admin" element={<Admin />}>
                    <Route path="update" element={<AdminUpdate />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
